export var colors = {
  grey: '#c4c5cd',
  greyLighter: '#f3f5f6',
  greyLight: '#e1e5e7',
  greyDark: '#9798a0',
  greyDarker: '#73747b',
  anthracite: '#080e31',
  green: '#11aaaa',
  greenDark: '#0f9999',
  greenDarker: '#0e8888',
  blue: '#363c58',
  blueDark: '#2f4255',
  blueDarker: '#2a3a4b',
  info: '#0099cc',
  success: '#00aa00',
  warning: '#ff9900',
  danger: '#cc0000',
  text: '#080e31',
  textLight: '#6f7076',
  background: '#e7ebed'
};
export var form = {
  widgetHeight: '40px',
  widgetHeightSmall: '32px'
};
export var fontSize = {
  base: '14px',
  small: '12px'
};
export var breakpoints = {
  baseem: '0.0625',
  // 1em / 16px
  xsmall: '27em',
  // 432px
  small: '40em',
  // 640px
  medium: '48em',
  // 768px
  large: '62.5em',
  // 1000px
  xlarge: '75em',
  // 1200px
  xxlarge: '90em',
  // 1440px
  wide: '105em',
  // 1680px
  xwide: '120em' // 1920px
};

export var spacings = {
  xxsmall: '4px',
  xsmall: '10px',
  small: '20px',
  base: '40px',
  medium: '80px',
  large: '160px',
  mobile: {
    xxsmall: '4px',
    xsmall: '10px',
    small: '15px',
    base: '30px',
    medium: '60px',
    large: '80px'
  }
};
export var circles = {
  size40: '16px',
  size60: '24px',
  size80: '32px',
  size100: '40px'
};
export var icons = {
  size20: '8px',
  size30: '12px',
  size40: '16px',
  size50: '20px'
};